const data = {
  api: "http://eformservice.com:5200"//http://122.155.13.119:5200
};

export default data;


// WEBPACK FOOTER //
// ./src/config.js